import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { UsernameValidator } from 'src/app/validation/password.validator';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-changepassword',
    templateUrl: './changePassword.component.html',
    styleUrls: ['./changePassword.component.scss'],
})
export class ChangepasswordComponent implements OnInit {
    public changepwdform: FormGroup;
    languageConext: any;
    headerTitle: any;
    currentpath;
    showoldpwd: boolean = true;
    oldpwd: any;
    passwordmismatch: boolean = false;
    formsubmitted: boolean = false;
    noOfFailure = 0;
    newpwd: any;
    retypepwd: any;

    constructor(public formBuilder: FormBuilder,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        public api: RestapiService,
        public _sanitizer: DomSanitizer,
        public actionVal: ActionlistenService) {

        this.currentpath = this.router.url;

        if (this.currentpath == "/forgotChangePassword") {
            this.showoldpwd = false;
            this.oldpwd = "Metlife!1"
            // this.changepwdform.value.oldpwd = "Metlife!1"
        }
        if (this.cmndeclaration.LanguageJson) {
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].Changepassword;
        }
        else {
            this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].Changepassword;
        }

        this.headerTitle = this.languageConext.heading.text;
        this.changepwdform = this.formBuilder.group({
            newpwd: new FormControl('', Validators.compose([
                UsernameValidator.validUsername,
                Validators.maxLength(20),
                Validators.minLength(6)
            ])),
            oldpwd: ['', Validators.required],
            retypepwd: new FormControl('', Validators.compose([
                UsernameValidator.validUsername,
                Validators.maxLength(20),
                Validators.minLength(6)
            ])),
        })
    }
    ngOnInit() {

    }


    retypepassword(ev) {
        if (ev.detail.value.length == 0) {
            this.passwordmismatch = false;
        }
        else {
            this.passwordmismatch = true
        }
    }


    changepassword() {
        if (this.currentpath == "/forgotChangePassword") {
            this.forgotChangePassword();
        } else {
            this.changePasswordInSideMenu();
        }
    }

    showinfo(msg) {
        this.cmndef.presentAlert("", msg, "info");
    }

    forgotChangePassword() {
        if (this.changepwdform.value.newpwd && this.changepwdform.value.retypepwd &&
            this.changepwdform.get('newpwd').valid && this.changepwdform.get('retypepwd').valid &&
            (this.changepwdform.get('retypepwd').value == this.changepwdform.get('newpwd').value)) {
            let data = JSON.parse(localStorage.getItem("forgotPasswordData"));
            data.userType2.password = this.changepwdform.value.newpwd;
            data.requestType = "FORGOTPASSWORD";
            this.api.postapi("userRegistration", data).then(response => {
                this.api.clickenventcap("changePasswordButton");
                if (response['responseCode'] == "001" && response['status'] == "Success") {
                    this.cmndef.presentAlert("", response['message'], "forgotpwdsuccess")
                }
                else if (response['responseCode'] == "002" && response['status'] == "Failure") {
                    this.cmndef.presentAlert("", response['message'], "forgotpwdfailure")
                }
            });
        }

    }

    async changePasswordInSideMenu() {
        if (this.changepwdform.valid && this.changepwdform.get('retypepwd').value == this.changepwdform.get('newpwd').value) {
            var data = {
                "requestType": "CHANGEPASSWORD",
                "oldPassword": this.changepwdform.value.oldpwd,
                "newPassword": this.changepwdform.value.newpwd,
                "userSessionID": localStorage.userSessionID,
                "userChatSessionId": localStorage.userChatSessionId
            };
            await this.api.postapi('loginAuthentication', data).then(async response => {
                if (response['responseCode'] == "001" && response['status'] == "Success") {
                    this.cmndeclaration.TamlismaJson = response["chatResp"][0];
                    sessionStorage.CurrentPage = "/va/chat";
                    this.navctrl.navigateRoot("/va/chat");
                }
                else if (response['responseCode'] == "002" && response['status'] == "Failure") {
                    this.cmndef.Showtoast(response['message'])
                    this.noOfFailure += 1;

                    if (this.noOfFailure == 3) {
                        this.logOutRediretToForgotPassword();
                    }
                }
            })
        }
    }
    logOutRediretToForgotPassword() {
        var data = {
            "requestType": "LOGOUT",
            "userSessionID": localStorage.userSessionID,
            "userChatSessionId": localStorage.userChatSessionId
        };
        this.api.postapi('loginAuthentication', data).then(response => {
            if (response['responseCode'] == "001" && response['status'] == "Success") {
                localStorage.setItem("notMannuallyLogedOut", 'false');
                sessionStorage.CurrentPage = "/forgotpassword";
                this.navctrl.navigateRoot("/forgotpassword")
            } else {

            }
        })
    }
    validatefun(event: any, flg: any) {

        if (flg == 'oldpwd') {
            this.oldpwd = this.oldpwd.replace(/^\s+|\s+$|\s+(?=\s)/g, '');
            this.oldpwd = this.oldpwd.replace(" ", '');
        }
        if (flg == 'newpwd') {
            this.newpwd = this.newpwd.replace(" ", '');

        }
        if (flg == 'retypepwd') {
            this.retypepwd = this.retypepwd.replace(" ", '');
        }
    }
}